module.exports = __webpack_public_path__ + "static/media/blog8_3.16cfc815.webp";